import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Header.css";

import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import Container from "react-bootstrap/container";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";

function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);

  const handleNavClick = () => {
    setExpanded(false);
  };

  const services = [
    { label: "Service & Maintenance", link: "/maintenance" },
    { label: "Body Repair (Dent & Paint)", link: "/body-repair" },
    { label: "Outstation Rides", link: "/outstation-rides" },
    { label: "Car Wash & Detailing", link: "/car-wash" },
    { label: "Pickup & Drop-off Service", link: "/pickup" },
    { label: "Vehicle Inspection & Valuation", link: "/inspection" },
    { label: "Towing Services", link: "/towing" },
  ];

  return (
    <section className="main_head">
      <div className="container-fluid p-0">
        <div className="container-md">
          <Navbar expand="lg" expanded={expanded} onToggle={setExpanded}>
            {/* Logo */}
            <Navbar.Brand as={Link} to="/">
              <div className="logodiv">
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/logo/logo.png"}
                  alt="Logo"
                  className="logo-img"
                />
              </div>
            </Navbar.Brand>

            {/* Toggle for mobile */}
            <Navbar.Toggle aria-controls="basic-navbar-nav" />

            {/* Navbar Links */}
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="">
                <Nav.Link
                  as={Link}
                  to="/"
                  className={location.pathname === "/" ? "active" : ""}
                  onClick={handleNavClick}
                >
                  Home
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to="/advantage"
                  className={location.pathname === "/advantage" ? "active" : ""}
                  onClick={handleNavClick}
                >
                  The Advantage
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to="/check-your-fit"
                  className={
                    location.pathname === "/check-your-fit" ? "active" : ""
                  }
                  onClick={handleNavClick}
                >
                  Check Your Earning
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to="/about-us"
                  className={
                    location.pathname === "/about-us" ? "active" : ""
                  }
                  onClick={handleNavClick}
                >
                 About Us
                </Nav.Link>

                {/* <NavDropdown title="Services" id="services-dropdown">
                  {services.map((item, idx) => (
                    <NavDropdown.Item
                      as={Link}
                      to={`services${item?.link}`}
                      // to={item.link}
                      key={idx}
                      onClick={handleNavClick}
                      className="dropdown-service-item d-flex justify-content-between align-items-center"
                    >
                      {item.label}
                      <FontAwesomeIcon
                        icon={faAngleRight}
                        className="angle_icon"
                      />
                    </NavDropdown.Item>
                  ))}
                </NavDropdown> */}
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </div>
      </div>
    </section>
  );
}

export default Header;
